<template>
  <section>
    <br>
    <p class="p-style">
      Step 2: Purpose of Visit
    </p>
    <div class="user-div">
      <p class="user-content">
        Location:- <font
          class="font-my-style"
        >
          {{ locationName.site_name }}
        </font>
      </p>
      <p class="user-content">
        Category:- <font
          v-if="userDetails.service_provider.contractor_category !== null"
          class="font-my-style"
        >
          {{ userDetails.service_provider.contractor_category.name }}
        </font>
        <font v-else>
          N/A
        </font>
      </p>
    </div>
    <v-card
      class="card-style"
      color="#ECEFF1"
      :style="getBgStyle"
    >
      <v-card-text class="justify-center">
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-container fluid>
            <v-textarea
              v-model="visitPurpose"
              dense
              :rules="[(v) => !!v || 'This field is required']"
              filled
              color="#000000"
              light
              outlined
              label="Visit Purpose*"
            />
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="#37474F"
                @click="cancel()"
              >
                Cancel
              </v-btn>
              <v-btn
                color="#FF3700"
                @click="gatherVisitPurpose()"
              >
                Next
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
    <br>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';

export default {
  name: 'GatherVisitPurpose',
  components: {
    'centre-spinner': spinner,
  },
  data: () => ({
    visitPurpose: null,
    loading: false,
    cardBgImg: require('@/assets/img/cardBg.png'),
    valid: false,
  }),
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
    userDetails () {
      return this.$store.getters.getUser;
    },
    locationName () {
      return this.$store.getters['swiftuser/getLocationName'];
    },
  },
  methods: {
    gatherVisitPurpose () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please fill the required fields before proceeding',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      this.$store.dispatch('swiftuser/saveVisitPurpose', {
        visit_purpose: this.visitPurpose,
      });
      this.loading = false;
      this.$emit('visit-purpose-stored');
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'HomePage' });
      }, 2000);
    },
  },
};
</script>
<style scoped>
.p-style {
  margin-left: 10px;
  color: #37474F;
  font-weight: bold;
  font-family: 'Times New Roman', Times, serif;
  font-size: 18px;
}
.card-style {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.user-content {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  margin-left: 10px;
  font-family:'Times New Roman', Times, serif;
}
.font-my-style {
  font-weight: bold;
  font-size: 16px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
  text-transform: capitalize;
}
.user-div {
  line-height:normal;
  border-left: 3px solid #FF3700;
  margin-left: 10px;
}
</style>
